var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('h1',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.title)}}),(_vm.subtitle)?_c('div',{domProps:{"textContent":_vm._s(_vm.subtitle)}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }